// extracted by mini-css-extract-plugin
module.exports = {"link":"ob_F7czUl","disabled":"ob_BhvQ4b","textType":"ob_XgyG1U","iconLink":"ob_qZkR1a","underlined":"ob_WY841K","iconBox":"ob_IL1n5J"};